// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"357":"df5b7e11","546":"48336e61","978":"888d81a8"}[chunkId] + ".chunk.css";
};